import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "./Topbar";
import TimeRemain from "./TimeRemain";
import Loader from "./Loader";
const apiBase = process.env.REACT_APP_API_URL;

const GlobalLeaderboard = () => {
  const [leaderboard, setLeaderboard] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(true);
  const now = new Date();
  const nextYear = now.getFullYear() + 1;
  const resetDate = new Date(`${nextYear}-01-01T00:00:00Z`).toISOString();

  useEffect(() => {
    const fetchLeaderboard = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${apiBase}/api/leaderboard/yearly`);
        setLeaderboard(data.leaderboard ?? []);
        setYear(data.year);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, []);

  if (loading) return <Loader loadingTitle={"Loading Leaderboard"} showLogo={true} />;

  return (
    <div className="page-container">
      <Topbar showLinks={false} showBudget={false} />
      <div className="main">
        <img src="/leaderboard-banner.png" style={{ width: "100%", borderRadius: "8px", objectFit: "scale-down", maxHeight: "164px" }} alt="Global Leadeboard Most Trophies"/>
        <p style={{ color: "white", fontSize: "14px", textAlign: "center", margin: "20px 5px" }}>
          Get rewarded for being a top manager. At the end of the season, 1st place earns 50$ LoL card, 2nd place earns $25, 3rd place earns
          $10.
        </p>
        <div className="leaderboard-container">
          {/* Header */}
          <div className="leaderboard-header">
            <h2 style={{ fontWeight: "700", letterSpacing: "-0.4px", fontSize: "14px" }}>MOST TROPHIES WON | {year}</h2>
            <TimeRemain startDate={resetDate} fontSize="14px" fontColor="white" />
          </div>
          {/* Leaderboard Content */}
          <div className="leaderboard-box">
            {leaderboard.length > 0 ? (
              <div className="leaderboard-list">
                {leaderboard.map((player, index) => {
                  const league_rank = index + 1;
                  return (
                    <React.Fragment key={player.user_id}>
                      <div className="leaderboard-row">
                        <div className={`leaderboard-dot ${league_rank <= 3 ? `rank-${league_rank}` : ""}`}></div>
                        <div className="left" style={{ cursor: "pointer" }}>
                          {player.profile_image && <img src={`/avatars/${player.profile_image}`} alt={player.display_name} />}
                          <span className={`name`}>{player.display_name}</span>
                        </div>
                        <div className="points" style={{ gap: 20, fontSize: "16px" }}>
                          <div className="leaderboard-rewards-container" style={{ display: "flex" }}>
                            {league_rank === 1 && (
                              <div style={{ display: "flex", flexDirection: " column", alignItems: "center" }}>
                                <img
                                  src={"https://m.media-amazon.com/images/I/81KCXLDPDZL._AC_UF1000,1000_QL80_.jpg"}
                                  alt="League Champion"
                                  style={{ height: "42px", borderRadius: "4px" }}
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    color: "white",
                                    margin: "-12px 0 0 0",
                                    textShadow: "rgba(0, 0, 0, 0.8) 0px 0px 8px",
                                    fontWeight: "900",
                                  }}>
                                  $50
                                </span>
                              </div>
                            )}
                            {league_rank === 2 && (
                              <div style={{ display: "flex", flexDirection: " column", alignItems: "center" }}>
                                <img
                                  src={"https://m.media-amazon.com/images/I/71DAl3cwFBL._AC_UF1000,1000_QL80_.jpg"}
                                  alt="League Champion"
                                  style={{ height: "42px", borderRadius: "4px" }}
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    color: "white",
                                    margin: "-12px 0 0 0",
                                    textShadow: "rgba(0, 0, 0, 0.8) 0px 0px 8px",
                                    fontWeight: "900",
                                  }}>
                                  $25
                                </span>
                              </div>
                            )}
                            {league_rank === 3 && (
                              <div style={{ display: "flex", flexDirection: " column", alignItems: "center" }}>
                                <img
                                  src={"https://m.media-amazon.com/images/I/71+y3JuOKKL._AC_UF1000,1000_QL80_.jpg"}
                                  alt="League Champion"
                                  style={{ height: "42px", borderRadius: "4px" }}
                                />
                                <span
                                  style={{
                                    fontSize: "16px",
                                    color: "white",
                                    margin: "-12px 0 0 0",
                                    textShadow: "rgba(0, 0, 0, 0.8) 0px 0px 8px",
                                    fontWeight: "900",
                                  }}>
                                  $10
                                </span>
                              </div>
                            )}
                          </div>
                          {player.trophies}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                <p
                  style={{
                    color: "rgb(83, 94, 108)",
                    fontSize: "14px",
                    textAlign: "center",
                  }}>
                  No trophies earned yet
                </p>
              </div>
            )}
          </div>
          {/* {showRewardsModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>League Rewards</h3>
              <button onClick={() => setShowRewardsModal(false)}>✕</button>
            </div>

            <div className="rewards-list">
              {leagueRewards
                .sort((a, b) => a.placement - b.placement)
                .map((reward) => (
                  <div key={reward.placement} className="reward-row">
                    <div className="placement">#{reward.placement}</div>

                    <div className="reward-items">
                      {reward.coins > 0 && (
                        <div className="reward-item">
                          <img src="/many-tokens.png" alt="Coins" />
                          <span>{reward.coins}</span>
                        </div>
                      )}

                      {reward.grants_international_ticket && (
                        <img src={reward.ticket_image || "/international-ticket.png"} alt="Ticket" className="ticket" />
                      )}
                      {reward.xp_boost && <img src="/single_boost.png" alt="XP Boost" className="ticket" />}
                      {reward.placement === 1 && !league.is_private && (
                        <img src={getTrophyImage(league.region)} alt="Champion Trophy" className="ticket" />
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )} */}
        </div>
      </div>
    </div>
  );
};

export default GlobalLeaderboard;
